import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPanchangAsync,
  updatePanchangAsync,
} from "../../data/redux/features/panchang/slice";
import CustomTable from "../../ui-compoenents/table";
import { Link } from "react-router-dom";
import AddPanchangFormModal from "./component/add-panchang-form-modal";
import { IoIosAddCircleOutline } from "react-icons/io";
import CommonConfirmationModal from "../../ui-compoenents/common-conformation-modal";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const Panchang = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const dispach = useDispatch();
  const { fetchLoading, loading, panchangData } = useSelector(
    (state) => state.panchang
  );

  useEffect(() => {
    dispach(getPanchangAsync());
  }, [dispach]);

  const columns = [
    {
      title: "Start Time",
      dataIndex: "start_time",
      key: "age",
    },
    {
      title: "End Time",
      dataIndex: "end_time",
      key: "name",
    },

    {
      title: "Samvat",
      dataIndex: "samvat",
      key: "address",
    },
    {
      title: "Day",
      dataIndex: "day",
      key: "age",
    },
    {
      title: "Active",
      dataIndex: "is_active",
      render: (_, record) => {
        return (
          <div>
            {record.is_active === "True" ? (
              <span className="badge badge-soft-success">True</span>
            ) : (
              <span className="badge badge-soft-danger">False</span>
            )}
          </div>
        );
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        return (
          <div
            className={`${
              record?.is_active === "True"
                ? "btn btn-sm btn-danger"
                : "btn btn-sm btn-success"
            }`}
            data-bs-toggle="modal"
            data-bs-target="#active-modal"
            onClick={() => setSelectedUser(record)}
          >
            {record?.is_active === "False" ? "Active" : "In Active"}
          </div>
        );
      },
    },
    // {
    //   title: "Nakshatra",
    //   render: (_, record) => {
    //     return (
    //       <button
    //         className="btn btn-primary"
    //         data-bs-toggle="modal"
    //         data-bs-target="#add_panchnag_form_modal"
    //         onClick={() => setSelectedUser(record)}
    //       >
    //         Add
    //       </button>
    //     );
    //   },
    // },
  ];

  return (
    <>
      <div className="p-4 bg-white rounded shadow-sm">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-3">Panchang List</h5>
          <Link
            to="#"
            className="btn btn-sm btn-primary fw-bold fs-14  "
            data-bs-toggle="modal"
            data-bs-target="#add_panchnag_form_modal"
            onClick={() => setSelectedUser(null)}
          >
            <IoIosAddCircleOutline className="me-1" />
            Add
          </Link>
        </div>

        <CustomTable
          dataSource={panchangData}
          columns={columns}
          loading={fetchLoading}
        />
      </div>

      <AddPanchangFormModal selectedUser={selectedUser} />
      <CommonConfirmationModal
        text={selectedUser?.is_active === "False" ? "In Active" : "Active"}
        buttonId="cancle-cancel"
        id="active-modal"
        loading={loading}
        icon={
          selectedUser?.is_active === "True" ? (
            <FaCheckCircle />
          ) : (
            <FaTimesCircle />
          )
        }
        variant={selectedUser?.is_active === "True" ? "success" : "danger"}
        onConfirm={async () => {
          try {
            if (selectedUser) {
              const result = await dispach(
                updatePanchangAsync({
                  updatePanchangValues: {
                    id: selectedUser?.id,
                    is_active: !selectedUser?.is_active,
                  },
                })
              ).unwrap();
              if (result) {
                const cancelButton = document.getElementById("cancle-cancel");
                cancelButton.click();
                setSelectedUser(null);
                // setSelectedTeacher(null);
                dispach(getPanchangAsync());
              }
            }
          } catch (error) {
            console.error(error);
          }
        }}
      />
    </>
  );
};

export default Panchang;
